import { render, staticRenderFns } from "./DocumentationListIndex.vue?vue&type=template&id=68a6cf65"
import script from "./DocumentationListIndex.vue?vue&type=script&lang=js"
export * from "./DocumentationListIndex.vue?vue&type=script&lang=js"
import style0 from "./DocumentationListIndex.vue?vue&type=style&index=0&id=68a6cf65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports